import {
    createStitches, defaultThemeMap,
} from '@stitches/react'

import {
    defaults,
} from './config.defaults'

export const {
    styled,
    css,
    globalCss,
    keyframes,
    getCssText,
    theme,
    createTheme,
    config,
} = createStitches({
    media: {small: '(max-width: 1200px)'},
    theme: {...defaults.theme},
    themeMap: {
        ...defaultThemeMap,
        backgroundSize: 'backgroundSizes',
        fontStyle: 'fontStyle',
        fontVariant: 'fontVariant',
        maxWidth: 'maxWidths',
    },
})

